module.exports = __webpack_public_path__ + "img/dank-mono-light.d464cd00.png";